import { Pipe, PipeTransform } from '@angular/core';
import { NotificationListDto } from '@common/generated-api/models/notification-list-dto';

@Pipe({
  name: 'notificationStatus',
})
export class NotificationStatusPipe implements PipeTransform {
  transform(status: NotificationListDto['sendStatus']): string {
    switch (status) {
      case 'PLAN':
        return $localize`Запланирован`;
      case 'SEND':
        return $localize`Отправлен`;
    }
  }
}
